// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs_separator":"breadcrumbV2_breadcrumbs_separator__1Pxbg","disable_breadcrumb":"breadcrumbV2_disable_breadcrumb__JPD0s"};